import { toHumanReadable } from 'beam/dist/utils/duration'
import Tooltip from 'beam/dist/Tooltip'
import PropTypes from 'prop-types'
import moment from 'moment'
import 'moment-timezone'
import { useTranslation } from 'react-i18next'

//TODO timezones will be addressed separately
const AssociatedContactTooltip = ({
  children,
  contact: { id, startTime, tz, ani, dnis, callDuration, agent, device, contactType, externalParty, toAddress, fromAddress, channel },
  onOpen,
  onClose,
}) => {
  const { t } = useTranslation()
  const contactMoment = moment.tz(startTime, tz)
  const contactDuration = moment.duration(callDuration)
  const agentId = agent ? (agent.displayId ? agent.displayId : `${agent.firstName} ${agent.lastName}`) : t('na')

  return (
    <Tooltip
      disableFocusListener
      placement="top-start"
      onOpen={onOpen}
      onClose={onClose}
      title={
        <div>
          <div>{`${t('ccrId')}: ${id}`}</div>
          <div>{`${t('interactionType')}: ${contactType ? t(contactType.toLowerCase()) : ''}`}</div>
          {channel ? <div>{`${t('channel')}: ${t(channel)}`}</div> : null}
          <div>{`${t('date')}: ${contactMoment.format('L')}`}</div>
          <div>{`${t('time')}: ${contactMoment.format('LTS')}`}</div>
          <div>{`${t('tz')}: ${tz ? tz : ''}`}</div>
          {contactType === 'CALL' || contactType === 'SMS' ? <div>{`${t('callingNumber')}: ${ani ? ani : ''}`}</div> : null }
          {contactType === 'CALL' || contactType === 'SMS' ? <div>{`${t('calledNumber')}: ${dnis ? dnis : ''}`}</div> : null }
          <div>{`${t('duration')}: ${toHumanReadable(contactDuration)}`}</div>
          <div>{`${t('agentId')}: ${agentId ? agentId : ''}`}</div>
          {externalParty && (contactType === 'CHAT' || contactType === 'SMS') ? <div>{`${t('externalParty')}: ${externalParty}`}</div> : null}
          {fromAddress && contactType === 'EMAIL' ? <div>{`${t('fromAddress')}: ${fromAddress}`}</div> : null}
          {toAddress && contactType === 'EMAIL' ? <div>{`${t('toAddress')}: ${toAddress}`}</div> : null}
          {device ? <div>{`${t('device')}: ${device}`}</div> : null}
        </div>
      }
    >
      {children}
    </Tooltip>
  )
}

AssociatedContactTooltip.propTypes = {
  contact: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
  onOpen: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
}

export default AssociatedContactTooltip
